import React, { useState } from 'react';
import Toast from './Toast';

export default function Industries() {
  const [toast, setToast] = useState(null);

  const showToast = (msg) => {
    setToast({ message: msg, type: 'default' });
    setTimeout(() => setToast(null), 3000);
  };

  return (
    <div className="admin-page">
      <div className="admin-page__head">
        <div>
          <h1 className="admin-page__title">Industries <em>· sectors served</em></h1>
          <div className="admin-page__sub">
            <span><strong>9</strong> industries</span>
            <span>Used by <strong>24</strong> projects</span>
          </div>
        </div>
        <div className="admin-page__actions">
          <button className="btn-primary" onClick={() => showToast('New industry created')}>+ New industry</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', marginTop: '32px' }}>
        {[1,2,3].map(idx => (
          <div key={idx} style={{ border: '1px solid rgba(244,241,234,0.08)', borderRadius: '2px', padding: '20px' }}>
            <span style={{ fontSize: '11px', color: 'var(--graphite-2)', fontFamily: 'Geist Mono' }}>/{idx}</span>
            <h3 style={{ fontSize: '18px', marginTop: '12px', marginBottom: '8px' }}>Industry Name</h3>
            <p style={{ fontSize: '13px', color: 'var(--graphite-2)', marginBottom: '16px', minHeight: '60px' }}>Description of the industry sector, services provided, and scope of expertise.</p>
            <div style={{ fontSize: '12px', color: 'var(--graphite-2)', marginBottom: '12px' }}>4 case studies</div>
            <button onClick={() => showToast('Delete confirm')} style={{ background: 'none', border: 'none', color: 'var(--graphite-2)', cursor: 'pointer', fontSize: '14px' }}>⋯</button>
          </div>
        ))}
      </div>

      {toast && <Toast message={toast.message} type={toast.type} />}
    </div>
  );
}
